/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FilterDescriptor model module.
 * @module model/FilterDescriptor
 * @version V1
 */
class FilterDescriptor {
    /**
     * Constructs a new <code>FilterDescriptor</code>.
     * @alias module:model/FilterDescriptor
     */
    constructor() { 
        
        FilterDescriptor.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FilterDescriptor</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FilterDescriptor} obj Optional instance to populate.
     * @return {module:model/FilterDescriptor} The populated <code>FilterDescriptor</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FilterDescriptor();

            if (data.hasOwnProperty('filter')) {
                obj['filter'] = ApiClient.convertToType(data['filter'], Object);
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
            if (data.hasOwnProperty('scope')) {
                obj['scope'] = ApiClient.convertToType(data['scope'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FilterDescriptor</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FilterDescriptor</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Object} filter
 */
FilterDescriptor.prototype['filter'] = undefined;

/**
 * @member {Number} order
 */
FilterDescriptor.prototype['order'] = undefined;

/**
 * @member {Number} scope
 */
FilterDescriptor.prototype['scope'] = undefined;






export default FilterDescriptor;

